import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0];
  return (
    <div className="bg-card border border-border rounded-lg shadow-lg px-3 py-2 text-xs">
      <span className="inline-block w-2 h-2 rounded-full mr-2 align-middle" style={{ backgroundColor: p.payload.color }} />
      <span className="text-foreground font-medium align-middle">{p.name}</span>
      <span className="text-muted-foreground ml-2 font-mono align-middle">{p.value}</span>
    </div>
  );
};

export const DonutChart = ({
  data = [], centerValue, centerLabel, innerRadius = 62, outerRadius = 90, height = 220,
}) => (
  <div className="relative" style={{ height }}>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          paddingAngle={3}
          cornerRadius={4}
          stroke="hsl(var(--card))"
          strokeWidth={2}
          animationBegin={200}
          animationDuration={1000}
          animationEasing="ease-out"
        >
          {data.map((d, i) => <Cell key={i} fill={d.color} />)}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </ResponsiveContainer>
    {centerValue != null && (
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="text-3xl font-bold text-foreground font-mono tabular-nums">{centerValue}</span>
        {centerLabel && <span className="text-xs text-muted-foreground mt-0.5">{centerLabel}</span>}
      </div>
    )}
  </div>
);
